module.exports = __webpack_public_path__ + "img/agent4.27059497.png";